import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { p as props, d as defaults } from './componentEl-33ff2aeb.js';
import 'prop-types';

/*
outermost wrapper for page, to limit width of page contents
separate from Grid because we don't always need to limit the width of the grid (e.g. nested grids)
*/

function PageWrapper(_ref) {
  let {
    componentEl: Component,
    className,
    children
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children"]);

  let cssClasses = ['st_pagewrapper'];
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}

PageWrapper.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** any extra CSS classes */
  className: classNameProps
};
PageWrapper.defaultProps = {
  componentEl: defaults,
  className: null
};

export default PageWrapper;
